/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_Product_DescInputs */

const en_shared_product_desc = /** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content shared to the discussion.`)
};

const es_shared_product_desc = /** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido compartido en la discusión.`)
};

const fr_shared_product_desc = /** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu partagé dans la discussion.`)
};

const de_shared_product_desc = /** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt in der Diskussion geteilt.`)
};

const id_shared_product_desc = /** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten dibagikan ke diskusi.`)
};

/** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */
const ja_shared_product_desc = en_shared_product_desc;

/** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */
const zh_shared_product_desc = en_shared_product_desc;

/** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */
const ar_shared_product_desc = en_shared_product_desc;

/** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */
const it_shared_product_desc = en_shared_product_desc;

/** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */
const ru_shared_product_desc = en_shared_product_desc;

/** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */
const pt_shared_product_desc = en_shared_product_desc;

/** @type {(inputs: Shared_Product_DescInputs) => LocalizedString} */
const ko_shared_product_desc = en_shared_product_desc;

/**
* | output |
* | --- |
* | "Content shared to the discussion." |
*
* @param {Shared_Product_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shared_product_desc = /** @type {((inputs?: Shared_Product_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_Product_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_product_desc(inputs)
	if (locale === "es") return es_shared_product_desc(inputs)
	if (locale === "fr") return fr_shared_product_desc(inputs)
	if (locale === "de") return de_shared_product_desc(inputs)
	if (locale === "ja") return ja_shared_product_desc(inputs)
	if (locale === "zh") return zh_shared_product_desc(inputs)
	if (locale === "ar") return ar_shared_product_desc(inputs)
	if (locale === "id") return id_shared_product_desc(inputs)
	if (locale === "it") return it_shared_product_desc(inputs)
	if (locale === "ru") return ru_shared_product_desc(inputs)
	if (locale === "pt") return pt_shared_product_desc(inputs)
	return ko_shared_product_desc(inputs)
});